import { useMutation, useQueryClient } from "react-query";
import { generateOpinion, createOpinion } from "../services/api";

// AI問題生成用カスタムフック（旧API - 後方互換性）
export const useGenerateOpinion = () => {
  return useMutation(generateOpinion, {
    retry: 1, // AI生成は1回のみリトライ
  });
};

// 生成した問題を保存用カスタムフック
export const useSaveGeneratedOpinion = () => {
  const queryClient = useQueryClient();

  return useMutation(createOpinion, {
    onSuccess: () => {
      // 保存成功後にキャッシュを更新
      queryClient.invalidateQueries("opinions");
      queryClient.invalidateQueries("opinionStats"); // 統計も更新
    },
  });
};
